/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useMemo, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { debounce } from "../../../utils/common";
import { capitalizeFirstLetter } from "../../helpers/format";

interface IAutocompleteSelect {
  name: string;
  label: string;
  onSelect: (data: any, isInitital?: boolean) => void;
  selectedValues: any;
  func: (...args: any) => Promise<any>;
  isReturnId?: boolean;
  touched?: boolean;
  error?: string;
  handleBlur?: (e: any) => void;
  filterOptions?: (options: any[], state: any) => any[];
  disabled?: boolean;
  helperText?: string;
}

const AutocompleteSelect: FC<IAutocompleteSelect> = ({
  onSelect,
  selectedValues,
  func,
  label,
  name,
  isReturnId = true,
  touched,
  error,
  handleBlur,
  filterOptions,
  disabled = false,
  helperText,
}) => {
  const [options, setOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [valueLabel, setValueLabel] = useState("");

  const handleInputChange = async (text: any, id?: number) => {
    setLoading(true);
    let data = await func(text, id);
    if (data && data.length > 0) {
      setOptions(data);
    }
    if (id && valueLabel?.length === 0) {
      setValueLabel(data[0]?.label);
    }
    setLoading(false);
  };

  const debounceHandleInputChange = useMemo(
    () => debounce(handleInputChange, 300),
    []
  );

  useEffect(() => {
    // debounceHandleInputChange("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedValues?.id) {
      setValueLabel(selectedValues?.name);
      onSelect(selectedValues, true);
    } else {
      if (valueLabel?.length === 0) {
        debounceHandleInputChange("", selectedValues);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValues]);

  const handleFilterOptions = (options: any[], state: any) => {
    if (filterOptions) {
      return filterOptions(options, state);
    }
    return options;
  };

  return (
    <>
      <Autocomplete
        className={disabled ? "bg-gray-300" : ""}
        disabled={disabled}
        value={selectedValues ? valueLabel || selectedValues : null}
        onChange={(_, newValue: any) => {
          setValueLabel(newValue?.label || "");
          onSelect(newValue);
        }}
        onInputChange={(_, newInputValue) => {
          if (newInputValue !== "loading ...") {
            if (newInputValue.length > 0) {
              debounceHandleInputChange(newInputValue);
            } else {
              setOptions([]);
            }
          }
        }}
        loading={loading}
        options={options}
        onBlur={handleBlur}
        filterOptions={handleFilterOptions}
        disableClearable={!selectedValues}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            label={label}
            error={Boolean(error && touched)}
            helperText={helperText || (touched && error ? capitalizeFirstLetter(error) : "")}
          />
        )}
      />
    </>
  );
};

export default AutocompleteSelect;
